"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.customStyleFn = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _EditorUtils = _interopRequireDefault(require("../EditorUtils"));
var _ColorPickerButton = _interopRequireDefault(require("./ColorPickerButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ColorControls extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      color: null
    };
  }
  componentWillReceiveProps(nextProps) {
    const editorState = nextProps.editorState;
    if (editorState !== this.props.editorState) {
      const currentStyle = editorState.getCurrentInlineStyle();
      const color = currentStyle.filter(value => value.startsWith('color')).last();
      if (color) {
        this.setState({
          color: color.replace('color:').replace(';', '').trim()
        });
      }
    }
  }
  onChangeColor(color) {
    const _this$props = this.props,
      editorState = _this$props.editorState,
      setEditorState = _this$props.setEditorState;
    const targetSelection = editorState.getSelection();
    if (!targetSelection.isCollapsed()) {
      const editorStateWithColor = _EditorUtils.default.toggleInlineStyle(editorState, "color: rgba(".concat(color.r, ",").concat(color.g, ",").concat(color.b, ",").concat(color.a, ");"));
      setEditorState(editorStateWithColor);
    }
  }
  hasColorStyle() {
    const editorState = this.props.editorState;
    const hasStyle = editorState.getCurrentInlineStyle().filter(style => style.startsWith('color'));
    return hasStyle.size > 0 ? 'active' : null;
  }
  render() {
    const _this$props2 = this.props,
      buttonClassName = _this$props2.buttonClassName,
      theme = _this$props2.theme;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "colorControls"
    }, /*#__PURE__*/_react.default.createElement(_ColorPickerButton.default, {
      theme: theme,
      className: (0, _classnames.default)(buttonClassName, this.hasColorStyle()),
      color: this.state.color,
      onRemoveColor: () => {},
      onChangeColor: this.onChangeColor.bind(this),
      focusEditor: this.props.focusEditor
    }));
  }
}
exports.default = ColorControls;
const customStyleFn = style => {
  const output = {};
  const color = style.filter(value => value.startsWith('color')).last();
  if (color) {
    output.color = color.replace('color:', '').replace(';', '').trim();
  }
  return output;
};
exports.customStyleFn = customStyleFn;